export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_17.c7b3d3ee.jpg";